import React, { useEffect, useState } from "react";
import { Row, Col, Button, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import { useStateValue } from "../../state";
import { manutencaoActions, selectPaginadoActions } from "../../actions";
import { FormatNumber } from '../../ValueObjects';
import { FiltroProdutoPdi, Tabela } from "../../components";
import { Edit } from "@material-ui/icons";

export default function TabItens({ formulario, dadosEndereco, dadosTabela, totalPedido, custo, dadosOperacao }) {

    const [{ manutencao }, dispatch] = useStateValue();

    function removerItem(item) {
        let dadosTemp = [...dadosTabela.dadosItens];
        dadosTemp = dadosTemp.filter((dados) => dados !== item);
        dadosTabela.setDadosItens(dadosTemp);
    };

    useEffect(() => {
        if (!!totalPedido && !!totalPedido.setTotalPedido) {
            let valorTotal = 0;
            if (!!dadosTabela && !!dadosTabela.dadosItens) {
                let seqKey = 0;
                dadosTabela.dadosItens.map(dado => {
                    valorTotal += dado.valorItemDesconto;
                    dado.key = seqKey;
                    seqKey++;
                });
            }
            totalPedido.setTotalPedido(valorTotal);
        }
    }, [dadosTabela.dadosItens]);

    function editarProdutos(item) {
        item.editando = true;
        item.percdesc = parseFloat(item.percdesc).toFixed(2)
        item.pdi_valordesconto = parseFloat(item.pdi_valordesconto).toFixed(2)

        let lista = [];
        if (!!item) {
            if (!!item.prg_id) {
                lista.push({ name: "pro_id", campo: "IdGrade", value: item.prg_id });
            } else {
                lista.push({ name: "pro_id", campo: "IdProduto", value: item.pro_id });
            }
        }
        dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: item } });
    };

    return (
        <div>
            <FiltroProdutoPdi  form={formulario} dadosTabela={dadosTabela} dadosEndereco={dadosEndereco} custo={custo} dadosOperacao={dadosOperacao} />
            <div className="tabela mt-dif">
                <Tabela colunas={[
                    {
                        width: 40,
                        render: ({ pro_codigo }) => (
                            <Tag color="processing">
                                <b>{pro_codigo}</b>
                            </Tag>
                        )
                    },
                    {
                        title: 'Itens',
                        width: 150,
                        render: ({ pro_descricao }) => (
                            <div>
                                <b> {pro_descricao}</b>
                            </div>
                        )
                    },
                    {
                        title: 'Qtde.',
                        align: 'center',
                        width: 30,
                        render: ({ pdi_quantidade, ump_id }) => (
                            <div>
                                <b>{pdi_quantidade} {ump_id}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Vlr Unit.(R$)',
                        align: 'right',
                        width: 40,
                        render: ({ pdi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(pdi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Desc.(%)',
                        align: 'center',
                        width: 40,
                        render: ({ percdesc }) => (
                            <div>
                                <b>{FormatNumber(percdesc, true)}%</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Vlr Total(R$)',
                        align: 'right',
                        width: 40,
                        render: ({ valorItemDesconto }) => (
                            <div>
                                <b>{FormatNumber(valorItemDesconto, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Ações',
                        dataIndex: '',
                        key: 'x',
                        align: 'center',
                        width: 40,
                        fixed: 'right',
                        render: (record) => (
                            <div>
                                <Row align="middle" justify="center" gutter={[5, 0]}>
                                    <Col>
                                        <Button icon={<EditOutlined />} onClick={() => { editarProdutos(record) }} />
                                    </Col>
                                    <Col>
                                        <Button icon={<DeleteOutlined />} onClick={() => { removerItem(record) }} />
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]} dados={dadosTabela.dadosItens} expandir={({ pro_ean, descricaograde, prg_ean }) => {
                    return (
                        <div>
                            <Row align="middle" gutter={[8, 0]}>
                                <Col>
                                    EAN: <b>{!!pro_ean ? pro_ean : prg_ean}</b>
                                </Col>
                                <Col >
                                    Grade: <b>{descricaograde}</b>
                                </Col>
                            </Row>
                        </div>
                    )
                }} />
            </div>
            <div className="m-t-16">
                <Row justify="end" align="middle" gutter={[8, 0]}>
                    <Col>
                        <span className="f-14"> Valor Total dos Itens (R$):</span>
                    </Col>
                    <Col>
                        <b className="f-16">
                            {FormatNumber(totalPedido.totalPedido, true)}
                        </b>
                    </Col>
                </Row>
            </div>
        </div>
    );
}